export const DOCTOR_SPECIALIZATIONS = [
  'All Specialties',
  'Cardiology',
  'Neurology',
  'Pediatrics',
  'General Medicine',
  'Orthopedics',
  'Dermatology',
  'Gastroenterology',
  'Endocrinology',
  'Pulmonology',
  'ENT (Otolaryngology)',
  'Psychiatry',
  'Gynecology & Obstetrics',
  'Oncology',
  'Nephrology',
];

// ZERO mock doctors - strictly real approved doctors from registration/admin
export const SEED_DOCTORS = [];

// ZERO mock slots - doctors create their own live slots
export const getSeedSlots = (doctorId) => [];
